import store from "../store";
import { onLogout } from "../store/slices/session/sessionService";

export const doLogout = (withRequest = true) => store.dispatch(onLogout(withRequest));
